import { c as _c } from "react/compiler-runtime";
import type { Actor as TActor } from '@onefootprint/request-types/dashboard';
import { CodeInline, Tag } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
export type ActorProps = {
  actor: TActor;
};
const formatName = (firstName?: string | null, lastName?: string | null, email?: string) => {
  const name = [firstName, lastName].filter(Boolean).join(' ').trim();
  if (name && email) return `${name} (${email})`;
  return name || email || '';
};
const Actor = t0 => {
  const $ = _c(32);
  const {
    actor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "actor"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  if (actor.kind === "user") {
    let t2;
    if ($[1] !== actor.id) {
      t2 = <div className="inline text-label-2 text-primary md:block"><CodeInline>{actor.id}</CodeInline></div>;
      $[1] = actor.id;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  if (actor.kind === "footprint") {
    let t2;
    if ($[3] !== t) {
      t2 = t(_temp);
      $[3] = t;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== t2) {
      t3 = <div className="inline text-label-2 text-primary md:block">{t2}</div>;
      $[5] = t2;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    return t3;
  }
  if (actor.kind === "firm_employee") {
    let t2;
    if ($[7] !== actor.email || $[8] !== actor.firstName || $[9] !== actor.lastName) {
      t2 = formatName(actor.firstName, actor.lastName, actor.email);
      $[7] = actor.email;
      $[8] = actor.firstName;
      $[9] = actor.lastName;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    const display = t2;
    if (!display) {
      let t3;
      if ($[11] !== t) {
        t3 = t(_temp2);
        $[11] = t;
        $[12] = t3;
      } else {
        t3 = $[12];
      }
      let t4;
      if ($[13] !== t3) {
        t4 = <div className="inline text-label-2 text-primary md:block">{t3}</div>;
        $[13] = t3;
        $[14] = t4;
      } else {
        t4 = $[14];
      }
      return t4;
    }
    let t3;
    if ($[15] !== display) {
      t3 = <span>{display}</span>;
      $[15] = display;
      $[16] = t3;
    } else {
      t3 = $[16];
    }
    let t4;
    if ($[17] !== t) {
      t4 = t(_temp3);
      $[17] = t;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    let t5;
    if ($[19] !== t4) {
      t5 = <Tag>{t4}</Tag>;
      $[19] = t4;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    let t6;
    if ($[21] !== t3 || $[22] !== t5) {
      t6 = <div className="inline-flex items-center gap-2 text-label-2 text-primary md:flex">{t3}{t5}</div>;
      $[21] = t3;
      $[22] = t5;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    return t6;
  }
  if (actor.kind === "organization") {
    let t2;
    if ($[24] !== actor.email || $[25] !== actor.firstName || $[26] !== actor.lastName) {
      t2 = formatName(actor.firstName, actor.lastName, actor.email);
      $[24] = actor.email;
      $[25] = actor.firstName;
      $[26] = actor.lastName;
      $[27] = t2;
    } else {
      t2 = $[27];
    }
    let t3;
    if ($[28] !== t2) {
      t3 = <div className="inline text-label-2 text-primary md:block">{t2}</div>;
      $[28] = t2;
      $[29] = t3;
    } else {
      t3 = $[29];
    }
    return t3;
  }
  if (actor.kind === "api_key") {
    let t2;
    if ($[30] !== actor.name) {
      t2 = <div className="inline text-label-2 text-primary md:block">{actor.name}</div>;
      $[30] = actor.name;
      $[31] = t2;
    } else {
      t2 = $[31];
    }
    return t2;
  }
  return null;
};
export default Actor;
function _temp($) {
  return $.footprint;
}
function _temp2($_0) {
  return $_0.firmEmployee;
}
function _temp3($_1) {
  return $_1.footprint;
}